import React from 'react'

const CheckBox = ({
  id, name, role, label, afterLabel, error, invalid, hint, inline, className,
  'aria-describedby': describedBy, ...props
}) => {
  const labelId = `${id}-label`
  const errorId = error && `${id}-error`
  const hintId = hint && `${id}-hint`

  return (
    <div className={[
      // BS5
      'form-check',
      role == 'switch' && 'form-switch',
      inline && 'form-check-inline',

      // BS4
      'custom-control',
      role == 'switch' ? 'custom-switch' : 'custom-checkbox',
      inline && 'custom-control-inline',

      // Misc
      `row-${id}`,
      className,
    ].filter(Boolean).join(' ')}>
      <input name={name} type="hidden" value="0" />
      <input
        type="checkbox"
        value="1"
        id={id}
        name={name}
        role={role}
        className={`form-check-input custom-control-input ${error || invalid ? 'is-invalid' : ''}`}
        aria-labelledby={labelId}
        aria-describedby={[ errorId, hintId, describedBy ].filter(Boolean).join(' ') || null}
        aria-invalid={error || invalid ? true : null}
        {...props}
      />
      <label
        className={`form-check-label custom-control-label ${afterLabel ? 'd-inline' : ''}`}
        htmlFor={id}
        id={labelId}
      >
        {/* Make Chrome read all labels consistently */}
        <span>{label}</span>
      </label>
      {' '}{afterLabel}
      {
        error &&
        <div id={errorId} className="invalid-feedback">{error}</div>
      }
      {
        hint &&
        <small id={hintId} className="form-text d-block text-muted">
          {hint}
        </small>
      }
    </div>
  )
}

export default CheckBox
